// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__1JKfV","label__helper":"style_label__helper__1twuM"};